import { createSlice } from "@reduxjs/toolkit";
import ReactGA from "react-ga4";

const alert = createSlice({
	name: "resetPassword",
	initialState: {
		isOpen: false,
		alert: null,
	},
	reducers: {
		setAlert(state, action) {
			state.alert = action.payload.alert;
		},
		toggleShowAlert(state, action) {
			if (!action.payload.isOpen) {
				ReactGA.event({
					category: "Alerta",
					action: "Mostrar alerta",
				});
			}
			state.isOpen = !action.payload.isOpen;
		},
	},
});

export const { setAlert, toggleShowAlert } = alert.actions;

export default alert.reducer;
